import { Icons } from '@commenda/kakashi';
import { cn } from '@commenda/utils';
import Link from 'next/link';

type BackButtonBaseProps = {
  label: string;
  className?: string;
};

type BackButtonProps = BackButtonBaseProps &
  ({ href: string; onClick?: never } | { onClick: () => void; href?: never });

const BACK_BUTTON_CLASSES =
  'group flex w-fit items-center gap-xs txt-extra-small-bold text-fg-primary transition-colors';

const BackButtonContent = ({ label }: { label: string }) => (
  <>
    <Icons.ChevronLeft className="size-4 transition-transform duration-150 ease-out group-hover:-translate-x-0.5" />
    <span className="text-fg-brand transition-colors duration-150 group-hover:text-fg-brand-hover">
      {label}
    </span>
  </>
);

export const BackButton = ({
  label,
  className,
  href,
  onClick,
}: BackButtonProps) =>
  href !== undefined ? (
    <Link href={href} className={cn(BACK_BUTTON_CLASSES, className)}>
      <BackButtonContent label={label} />
    </Link>
  ) : (
    <button
      type="button"
      onClick={onClick}
      className={cn(BACK_BUTTON_CLASSES, className)}
    >
      <BackButtonContent label={label} />
    </button>
  );
